const feathers = require('@feathersjs/feathers');
const rest = require('@feathersjs/rest-client');
const auth = require('@feathersjs/authentication-client');
const axios = require('axios');

// Base URL determined by the env variables 
const BASE_URL = process.env.VUE_APP_BEEZ_API_URL || 'https://beez-erp.uc.r.appspot.com/';

const app = feathers();

const restClient = rest(BASE_URL);
app.configure(restClient.fetch(window.fetch))
app.configure(auth({
    storage: window.localStorage,
    storageKey: 'beez-jwt-token'
}))

// below are the services
export const userService = app.service('users');
export const applicantCardService = app.service('applicant-card');
export const authService = app.authentication.service;
export const beezInCodeValidationService = app.service('validate-beez-in-code');
export const commentService = app.service('group-messages');
export const selectorRatingService = app.service('selectors-rating');
export const searchingService = app.service('search-applicant-card');
export const beezcoveryService = app.service('selector-beezcovery');
export const beezhiveService = app.service('selector-hive');
export const excelService = app.service('application-submission-report')
const appSubmissionModuleService = app.service('application-submissions-module');
const exportApplicantFilesService = app.service('export-applicant-files');

export async function getSubmissionModule(id) {
    return await appSubmissionModuleService.get(id);
}

export async function createProfile(profile) {
    return await applicantCardService.create(profile);
}
export async function updateProfile(profile) {
    return await applicantCardService.patch(profile._id, profile);
}
export async function validPassport(id, PassportValid) {
    return await applicantCardService.patch(id, {
        isPassportValid: PassportValid
    });
}
export async function saveProfileField(id, fieldName, fieldValue) {

    let payload = {};

    // map the new value to the relevant field dynamically
    // this way we can avoid writing function for every auto save that we're doing 
    payload[fieldName] = fieldValue;

    return await applicantCardService.patch(id, payload);
}

export async function submitUserApplication(id) {
    return await applicantCardService.patch(id, {
        isComplete: true
    });
}


export async function saveEligibilityChecked(applicantId) {
    return await applicantCardService.patch(applicantId, {
        isEligible: true
    });
}

export async function filesUpload(file) {

    const token = await app.authentication.getAccessToken();

    return await axios.post(`${BASE_URL}/files`, file, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': token

        }
    }).then(response => {
        return response.data
    }).catch((err) => { return err.response.data })


}

export async function loginUser(email, password) {
    const user = await app.authenticate({
        strategy: 'local',
        email: email,
        password: password
    })

    return user;
}

export async function logoutUser() {
    await app.authentication.removeAccessToken();
    return await app.logout();
}

export async function getCards(limit, skip) {
    const token = await app.authentication.getAccessToken();

    return await applicantCardService.find({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        query: {
            $limit: limit,
            $skip: skip,
            isComplete: true
        }
    })
}

export async function getRatedApplicants(limit, skip) {
    const token = await app.authentication.getAccessToken();
    return await beezhiveService.find({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        query: {
            $limit: limit,
            $skip: skip,
            isComplete: true
        }
    })
}

export async function getUnratedApplicants(limit, skip) {
    const token = await app.authentication.getAccessToken();
    return await beezcoveryService.find({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
        query: {
            $limit: limit,
            $skip: skip, 
            isComplete: true
        }
    })
}

export async function getCardForUserId(userId) {
    return await applicantCardService.find({
        query: {
            userId: userId
        }
    });
}

export async function getCard(id) {
    return await applicantCardService.find({
        query: {
            _id: id
        }
    });
}

// export async function searchApplicantsCard(word) {
//     return await applicantCardService.find({
//         query: {
//             $text:
//             {
//                 $search: word
//             }
//         }
//         // query: {
//         //     userId: word
//         // }
//     })
// };

export async function searchApplicantsCard(word, onlyRated) {
    const token = await app.authentication.getAccessToken();
    // console.log("SEARCH feathers", word, onlyRated);
    return await searchingService.create({
        "value": word,
        "onlyRated": onlyRated
    },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
        });
}
export async function rateApplicant(academicRating, experienceRating, overallRating, applicantCardId) {
    const token = await app.authentication.getAccessToken();

    return await selectorRatingService.create({
        academicRating: academicRating,
        experienceRating: experienceRating,
        overallRating: overallRating,
        applicantCardId: applicantCardId
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })
}
export async function generateExcel() {
    const token = await app.authentication.getAccessToken();

    return await excelService.create({
        name: "ENELOAP2019"
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
    });
}
export async function rateApplicantEdit(ratingId, academicRating, experienceRating, overallRating, applicantCardId) {
    const token = await app.authentication.getAccessToken();

    return await selectorRatingService.patch(ratingId, {
        academicRating: academicRating,
        experienceRating: experienceRating,
        overallRating: overallRating,
        applicantCardId: applicantCardId
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })
}

export async function currentUser() {
    const user = await app.get('authentication');
    return user;
}

export async function signupUser(email, password, accountId, appSubmissionId) {

    const user = await userService.create({
        email: email,
        password: password,
        accountsIds: [accountId],
        type: "APPLICANT",
        applicationSubmissionId: appSubmissionId
    });

    return user;

}

export async function reauth() {
    return await app.authentication.reAuthenticate();
}

export async function authenticateWithBeezcode(bcode) {
    let bool = await app.authenticate({
        strategy: 'local',
        code: bcode
    }).then(() => { return true }).catch(() => { return false });
    return bool
}

export async function userData(bcode) {
    let userdata = await app.authenticate({
        strategy: 'local',
        code: bcode
    }).then((response) => {
        const data = {
            moduleRefId: response.moduleRefId,
            accountId: response.accountId
        }
        return data

    }).catch((err) => console.error(err))
    return userdata
}

export async function emailVerification(code, email) {
    return await app.service('authmanagement').create({
        action: 'verifySignupShort',
        value: {
            user: {
                email: email
            },
            token: code
        }
    });
}

export async function sendVerificationCode(email) {
    return await app.service('authmanagement').create({
        action: 'resendVerifySignup',
        value: {
            email
        }
    });
}

export async function getSelectorComments(skip, groupConversationId) {

    const token = await app.authentication.getAccessToken();
    return await commentService.find({
        headers: {
            'Authorization': token
        },
        query: {
            $skip: skip,
            $limit: 50,
            groupConversationId
        }
    })
}

export async function createComment(groupConversationId, comment, messageType) {
    const token = await app.authentication.getAccessToken();
    const commented = await commentService.create({
        groupConversationId: groupConversationId,
        text: comment,
        messageType: messageType

    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token

        }
    });

    return commented;
}

export async function resetPassword(email) {
    return await app.service('authmanagement').create({
        action: "sendResetPwd",
        value: {
            email: email
        }
    });
}
export async function editComment(selectorId, editText) {
    const token = await app.authentication.getAccessToken();
    const edited = await commentService.patch(selectorId, {
        text: editText
    }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token

        }
    });
    return edited;
}

export async function downloadApplicantZip(applicantId) {

    return await app.service('export-applicant-files').create({
        applicantId: applicantId
    });
}